import { runEditProgramRequestFlow } from '../shared/runEditProgramRequestFlow';
import { toEditMergeRequest } from './mergeProgramsModel';
import { programRequestsApi } from '../api/programRequestsApi';

export const editMergeProgramsFlow = ({
    form,
    details,
    onError,
    api = programRequestsApi,
}) =>
    runEditProgramRequestFlow({
        request: toEditMergeRequest(form, details),
        onError,
        updateRequest: api.updateMergeRequest,
    });
